import type { ReactNode } from 'react'

/** The title row for Admin section cards. Metadata stays beside the title; actions align right. Both are siblings
 * of the heading, so the section's accessible name stays its title. */
export function SectionHeader({
  title,
  id,
  level = 2,
  meta,
  actions,
  description,
  className,
}: {
  title: ReactNode
  id?: string
  level?: 2 | 3
  /** Badges, counts, FieldHelp or OperatorFaqTrigger beside the title. */
  meta?: ReactNode
  /** Links or buttons at the right; wrap below the title when space is tight. */
  actions?: ReactNode
  description?: ReactNode
  /** Layout spacing only; title typography is shared. */
  className?: string
}): JSX.Element {
  const Heading = level === 3 ? 'h3' : 'h2'
  return (
    <header data-slot="section-header" className={className}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 max-w-full flex-wrap items-center gap-2">
          <Heading id={id} className="text-body font-semibold text-text-primary">{title}</Heading>
          {meta}
        </div>
        {actions && <div className="ml-auto flex max-w-full flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {description && <div className="mt-1 text-body text-text-secondary">{description}</div>}
    </header>
  )
}
